export const events = {
	1: [],
	2: [],
	3: [
		{
			name: 'Cyber Fest',
			season: 't1',
		},
	],
	4: [
		{
			name: 'Semana Santa',
			season: 't2',
		},
	],
	5: [
		{
			name: 'Hot Sale',
			season: 't1',
		},
	],
	6: [
		{
			name: 'DDP',
			season: 't2',
		},
	],
	7: [],
	8: [
		{
			name: 'DDN',
			season: 't2',
		},
	],
	9: [],
	10: [
		{
			name: 'DDM',
			season: 't2',
		},
	],
	11: [
		{
			name: 'Cyber Monday',
			season: 't1',
		},
		{
			name: 'Black Friday',
			season: 't1',
		},
	],
	12: [
		{
			name: 'Navidad',
			season: 't1',
		},
	],
};
